import React  from "react";
import { Button } from 'reactstrap';

import DrahonHitTokenImg from "~/assets/images/tournament/dragonHitId.png";
import NinjaHikeTokenImg from "~/assets/images/tournament/NinjaHikeToken.jpg";

const DrahonHitTokenInfo = ({setOverlayOpen, gameId})=> {

  return (
    <div className="dragon-hit-token-info text-center">
      <img src={gameId === 1 ? DrahonHitTokenImg : NinjaHikeTokenImg} />

      <Button className="close-x" color="dark" onClick={()=> setOverlayOpen(false)}>&times;</Button>
      <p>Copy Paste the ID code from the game into the ED TOKEN field</p>
      <Button color="dark" onClick={()=> setOverlayOpen(false)}> Close </Button>
    </div>
  );
};

export default DrahonHitTokenInfo;
